import { ProfileComplete } from "./api";

const STORAGE_KEY = "teagram_profile_data";

export const storage = {
  saveProfileData: (data: ProfileComplete): void => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  },

  getProfileData: (): ProfileComplete | null => {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  },

  hasSearchedBefore: (): boolean => {
    return localStorage.getItem(STORAGE_KEY) !== null;
  },

  clearProfileData: (): void => {
    localStorage.removeItem(STORAGE_KEY);
  },
};
